'use client'

import { useNavigateBack } from '@/hooks/use-navigate-back'
import { AppRoutes } from '@/routes'
import { cn } from '@/utils/cn'
import Image from 'next/image'
import Link from 'next/link'

export const ProductDetailHeader = ({ className }: { className?: string }) => {
  const { onClickBackButton } = useNavigateBack()
  return (
    <header
      className={cn(
        'flex w-full items-center justify-between px-[20px] py-[16px]',
        className,
      )}
    >
      <button onClick={onClickBackButton}>
        <Image
          src="/icons/nav-chevron-left.svg"
          alt=""
          width={24}
          height={24}
        />
        <span className="sr-only">뒤로가기</span>
      </button>

      <div className="flex items-center gap-[10px]">
        <Link href={AppRoutes.home()} id={'nav_header_home'}>
          <Image src="/icons/nav-home.svg" alt="" width={24} height={24} />
          <span className="sr-only">홈</span>
        </Link>
        <Link
          href={AppRoutes.myNotifications()}
          id={'nav_header_my-notifications'}
        >
          <Image src="/icons/nav-alarm.svg" alt="" width={24} height={24} />
          <span className="sr-only">알람</span>
        </Link>
        <Link href={AppRoutes.search()} id={'nav_header_search'}>
          <Image
            src="/icons/nav-search.svg"
            alt="검색"
            width={24}
            height={24}
          />
          <span className="sr-only">검색</span>
        </Link>
      </div>
    </header>
  )
}
